import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import {
  MatLegacyDialog as MatDialog,
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';

import { FoldersTabViewFileComponent } from 'app/shared/modules/folders/view-file/view-file.component';
import { FileResource } from 'app/shared/modules/folders/folders.types';
import { MailboxService } from '../services/mailbox.service';
import { Mail } from '../mailbox.types';
import { Data } from '@angular/router';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { filter } from 'rxjs/operators';
import { ConfirmService } from '../../dialog/confirm/confirm.service';

@Component({
  selector: 'mailbox-mail-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MailboxMailViewComponent extends OnDestroyMixin implements OnInit {
  email: Mail;

  private _accountId: number;

  constructor(
    @Inject(MAT_DIALOG_DATA) private readonly _data: Data,
    private readonly _matDialogRef: MatDialogRef<MailboxMailViewComponent>,
    private readonly _matDialog: MatDialog,
    private readonly _mailboxService: MailboxService,
    private readonly confirmService: ConfirmService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.email = this._data.email;
    this._accountId = this._data.accountId;
  }

  openEmail(): void {
    if (this.email.data.web_link) {
      window.open(this.email.data.web_link, '_blank');
    }
  }

  viewFile(fileResource: FileResource | FileResource[]): void {
    if (!fileResource) {
      return;
    }

    fileResource = Array.isArray(fileResource) ? fileResource[0] : fileResource;

    this._matDialog.open(FoldersTabViewFileComponent, {
      panelClass: 'mailbox-compose-dialog',
      minWidth: '100vw',
      height: '100vh',
      data: { fileResource },
    });
  }

  onDeleteEmail(email: Mail): void {
    this.confirmService
      .openConfirmationModal({
        message: 'Are you sure you want to delete this email?',
      })
      .pipe(filter((result: boolean) => result))
      .subscribe(() => {
        this._mailboxService
          .deleteMail(this._accountId, email.id)
          .pipe(untilComponentDestroyed(this))
          .subscribe(() => this._matDialogRef.close());
      });
  }

  trackByFn(index: number, item: any): number | string {
    return item.id || index;
  }

  onClose(): void {
    this._matDialogRef.close();
  }
}
